import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';


const tick = (loopNum, isDeleting, text, period, setLoopNum, setIsDeleting, setText, setDelta) => {
  const toRotate = ["Software Engineer", "Full Stack Developer", "Web Developer"];
  let i = loopNum % toRotate.length;
  let fullText = toRotate[i];
  let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

  setText(updatedText);

  if (isDeleting) {
    setDelta(prevDelta => prevDelta / 2);
  }

  if (!isDeleting && updatedText === fullText) {
    setIsDeleting(true);
    // setIndex(prevIndex => prevIndex - 1);
    setDelta(period);
  } else if (isDeleting && updatedText === '') {
    setIsDeleting(false);
    setLoopNum(loopNum + 1);
    // setIndex(1);
    setDelta(500);
  } else {
    // setIndex(prevIndex => prevIndex + 1);
  }
};


export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  // const [index, setIndex] = useState(1);
  // const toRotate = ["Software Engineer", "Full Stack Developer", "Web Developer"];
  const period = 500;


  useEffect(() => {
    let ticker = setInterval(() => {
      tick(loopNum, isDeleting, text, period, setLoopNum, setIsDeleting, setText, setDelta);
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text, delta, isDeleting, loopNum])



  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>{`Hi! I'm Kartik`} <span className="txt-rotate" dataPeriod="500" data-rotate='[ "Software Engineer", "Full Stack Developer", "Web Developer"]'><span className="wrap">{text}</span></span></h1>
                  <p>Hello there, I'm an enthusiastic and result-oriented Software Engineer with extensive software engineering experience of over two years. I excel at developing maintainable solutions for complex software problems. The more complex a problem is, the more I'm intrigued.</p>
                  <a href="https://docs.google.com/document/d/1uarZmHLy4EjW7Oo6ZXE6l8obSE_Z0Ece/edit?usp=sharing&ouid=108964506302422504600&rtpof=true&sd=true" target="_blank" rel="noreferrer" className="btn btn-primary" >Download Resume <ArrowRightCircle /></a>
                </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
